import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

import { GrSkeletonLoaderComponent } from '../skeleton-loader';
import {
  GR_WIDGET_LOADER_AREA_PATH,
  GR_WIDGET_LOADER_AXIS_TICK_COUNT,
  GR_WIDGET_LOADER_BAR_HEIGHTS,
  GR_WIDGET_LOADER_LEGEND_COUNT,
  GR_WIDGET_LOADER_LINE_PATH,
  GR_WIDGET_LOADER_ROW_WIDTHS,
} from './widget-loader.types';
import type { GrWidgetLoaderVariant } from './widget-loader.types';

// SVG ids are document-global. Several widgets load at once on a dashboard, so
// each instance needs its own gradient id or they all paint the first one's.
let gradientSequence = 0;

@Component({
  selector: 'gr-widget-loader',
  imports: [GrSkeletonLoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { style: 'display: contents;' },
  templateUrl: './widget-loader.component.html',
})
export class GrWidgetLoaderComponent {
  readonly variant = input<GrWidgetLoaderVariant>('line');
  readonly ariaLabel = input<string>('');
  readonly styleClass = input<string>('');

  protected readonly linePath = GR_WIDGET_LOADER_LINE_PATH;
  protected readonly areaPath = GR_WIDGET_LOADER_AREA_PATH;
  protected readonly barHeights = GR_WIDGET_LOADER_BAR_HEIGHTS;
  protected readonly rowWidths = GR_WIDGET_LOADER_ROW_WIDTHS;
  protected readonly axisTicks = Array.from({ length: GR_WIDGET_LOADER_AXIS_TICK_COUNT });
  protected readonly legendItems = Array.from({ length: GR_WIDGET_LOADER_LEGEND_COUNT });

  protected readonly gradientId = `gr-widget-loader-fill-${gradientSequence++}`;
  protected readonly areaFill = `url(#${this.gradientId})`;

  protected readonly rootClasses = computed<string>(() => {
    const classes = [
      'gr-widget-loader',
      `gr-widget-loader--${this.variant()}`,
      'flex',
      'h-full',
      'w-full',
      'flex-col',
    ];
    const extra = this.styleClass();
    if (extra) classes.push(extra);
    return classes.join(' ');
  });
}
